module.exports = __webpack_public_path__ + "static/media/ulrich_faber.dc53e165.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/images/mitarbeiter/ulrich_faber.png
// module id = 434
// module chunks = 0